<template>
  <div class="myTable">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">处理状态：</span>
            <el-select v-model="searchInfo.warningStatus" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in closeList" :key="i" :label="item.value" :value="item.status"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">客户名称：</span>
            <el-input v-model="searchInfo.name" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">联&nbsp;&nbsp;系&nbsp;人：</span>
            <el-input v-model="searchInfo.contactName" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">客户类型：</span>
            <el-select v-model="searchInfo.customersType" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in customersTypeList" :key="i" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">&nbsp;&nbsp;&nbsp;电&nbsp;&nbsp;&nbsp;话：</span>
            <el-input v-model="searchInfo.telephoneNumber" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">详细地址：</span>
            <el-input v-model="searchInfo.address" clearable placeholder="请输入"></el-input>
          </div>
<!--          <div class="search-item">-->
<!--            <span class="label">设&nbsp;&nbsp;备&nbsp;号：</span>-->
<!--            <el-input v-model="searchInfo.imei" clearable placeholder="请输入"></el-input>-->
<!--          </div>-->
<!--          <div class="search-item">-->
<!--            <span class="label">探&nbsp;&nbsp;头&nbsp;数：</span>-->
<!--            <el-input v-model="searchInfo.probeCount" clearable placeholder="请输入"></el-input>-->
<!--          </div>-->
          <div class="search-item date-picker">
            <span class="label">预警时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="warningOrderNo" label="预警单号" width="150" ></el-table-column>
        <el-table-column prop="warningStatus" label="预警状态" >
          <template slot-scope="scope">
            {{ scope.row.warningStatus | showWarningStatus }}
          </template>
        </el-table-column>
        <el-table-column prop="isSms" label="短信">
          <template slot-scope="scope">
            {{ scope.row.isSms == 0?'未发送':scope.row.isSms == 1?"发送成功":"发送失败"}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="客户名称" width="120" ></el-table-column>
        <el-table-column prop="inUseNum" label="在用探头" width="70">
          <template slot-scope="scope">
            <span style="font-size: 14px;font-weight: 500;color: red;display: block; text-align: center;">{{ scope.row.inUseNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="threshold" label="阈值" width="50">
          <template slot-scope="scope">
            <span style="font-size: 14px;font-weight: 500;color: blue;display: block; text-align: center;">{{ scope.row.threshold }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devNum" label="绑定数量" width="70">
          <template slot-scope="scope">
            <span style="display: block; text-align: center;">{{ scope.row.devNum }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="contactName" label="联系人" width="80" ></el-table-column>
        <el-table-column prop="phone" label="客户手机" width="100" ></el-table-column>
        <el-table-column prop="telephoneNumber" label="固定号码" width="100" ></el-table-column>
        <el-table-column prop="createTime" label="预警时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" label="业务人" ></el-table-column>
        <el-table-column prop="salesmanPhone" label="业务手机" width="100"></el-table-column>

        <el-table-column prop="address" label="地址" width="200"  ></el-table-column>
        <el-table-column prop="employeeCount" label="用水人数" ></el-table-column>
        <el-table-column prop="customersType" label="客户类型" ></el-table-column>




        <el-table-column
                fixed="right"
                label="操作"
                width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('early-warning-stat:view')"  @click="moreInfo(scope.row)">详情</el-button>
            <span v-if="$can('early-warning-stat:deal')">
              <el-button type="text" size="small" v-if="scope.row.warningStatus == 0" @click="confirmClose(scope.row)">处理</el-button>
              <el-button type="text" size="small" v-else style="color: #ccc; padding: 5px;">处理</el-button>
            </span>
            <span  v-if="$can('early-warning-stat:sim')">
              <span v-if="scope.row.warningStatus != 2">
                <el-button type="text" size="small" v-if="scope.row.isSms == -1" @click="confirmRemove(scope.row)">再发短信</el-button>
                <el-button type="text" size="small" v-if="scope.row.isSms == 0" @click="confirmRemove(scope.row)">发送短信</el-button>
                <el-button type="text" size="small" v-if="scope.row.isSms == 1" style="color: #ccc; padding: 5px;" >发送短信</el-button>
              </span>
              <span v-else>
                <el-button type="text" size="small"  style="color: #ccc; padding: 5px;" >发送短信</el-button>
              </span>

            </span>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <div>
      <el-dialog
              title="详情"
              :visible.sync="moreInfoDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户类型：">
                      {{addInfo.customersType}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名称：">
                      {{addInfo.name}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用水人数：">
                      {{addInfo.employeeCount}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电话：">
                      {{addInfo.phone}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="地址：">
                      {{addInfo.address}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备号：">
                      {{addInfo.imei}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="探头数：">
                      {{addInfo.probeCount}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="阈值：">
                      {{addInfo.threshold}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="ICCID：">
                      {{addInfo.iccid}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在用探头：">
                      {{addInfo.inUseNum}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="短信状态：">
                      {{addInfo.isSms== 0?'未发':'已发'}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="短信时间：">
                      {{addInfo.smsTime}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="处理时间：">
                      {{addInfo.manualCloseTime}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="关闭时间：">
                      {{addInfo.reportCloseTime}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="预警状态：">
                      {{addInfo.warningStatus | showWarningStatus}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  export default {
    name: "white-list",
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'新增客户',
        total:1,
        tableData: [],
        searchDateArr: [],
        loading: false,
        tableLoading: false,
        moreInfoDialogVisible: false,
        deviceBindingDialogVisibleList: false,
        deviceBindingDialogVisible: false,
        currentPage:1,
        customersTypeList:[], // 客户类型
        salesmanAndPartnerList:[], // 客户类型
        currentPhoneNumber:'',
        addInfo:{},
        bindingInfo:{
          customersId:'',
          imei:'',
          remark:'',
        },
        searchInfo:{
          warningOrderNo:'',
          name:'',
          contactName:'',
          customersType:'',
          phone:'',
          address:'',
          telephoneNumber:'',
          imei:'',
          probeCount:'',
          threshold:'',
          power:'',
          type:'',
          inUseNum:'',
          isSms:'',
          warningStatus:'',
          reportClose:'',
          searchDate:'',
          pageNumber:1,
          pageSize:50,
        },
        smsList:[{"status":"0","value":"未发"},{"status":"1","value":"已发"}],
        closeList:[{"status":"0","value":"未处理"},{"status":"1","value":"处理中"},{"status":"2","value":"已处理"}],
        customerContactsList:[{"name":"","phone":"","post":""}],
        rules: {
          name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          phone: [
            { required: false, message: '请输入电话', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请输入电话'));
                } else if (!vm.validatePhoneNumber(value)) {
                  callback(new Error('输入的固定电话格式有误，请修改！'));
                } else {
                  callback();
                }
              }, trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }]
        },

      }
    },
    watch: {
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.type'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.phone'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.address'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchDateArr'(newVal,oldVal){
        if (null == newVal){
          this.searchInfo.searchDate ="";
          this.pageInfo();
        }
      },
    },
    created: function () {
      this.pageInfo();
      // this.getPaymentTermList();
      this.getCustomersTypeList();
      this.getSalesmanAndPartnerList();
    },
    methods:{
      search(){
        this.pageInfo();
      },
      addRow(){
        this.customerContactsList.push({"name":"","phone":"","post":""});
      },
      removeRow(index){
        this.customerContactsList.splice(index, 1);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      validate(){

        let flag = true;
        let msg  = "";
        return {code:flag,msg:msg}
      },
      saveDeviceBinding(){
        axios.post('/devInfo/deviceBinding',this.bindingInfo).then(result => {
          if (result.code !== 200){
            console.log(result);
            this.msg("当前设备处于 "+result.message +" 状态，请更换其他的设备号。");
          }else {
            this.deviceBindingDialogVisible = false;
            this.getDeviceBindingList();
            this.pageInfo();
          }
        }).catch(err => {
          console.log(err);
        });
      },

      addForm(){
        //显示弹出
        this.deviceBindingDialogVisible = true;
        this.bindingInfo.imei = "";
        this.bindingInfo.remark = "";
      },
      confirmRemove(obj){
        this.$confirm('给业务员：'+obj.salesmanName+' 发送短信, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendSms(obj);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发送'
          });
        });
      },
      confirmClose(obj){
        this.$confirm('请确定处理 '+obj.name+' 的预警, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.manualClose(obj.id);
          this.$message({
            type: 'success',
            message: '手动关闭成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭'
          });
        });
      },
      removeDeviceBinding(obj){
        this.$confirm('确定解绑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbinding(obj);
          this.$message({
            type: 'success',
            message: '解绑成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      moreInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.moreInfoDialogVisible = true;
        //.getContactsLists(this.addInfo.id);
      },
      handleRowDblClick(row, column, event) {
        this.addInfo =JSON.parse(JSON.stringify(row));
        this.moreInfoDialogVisible = true;
        //this.getContactsLists(this.addInfo.id);
      },
      confirmChangeState(obj){
        let operation = obj.enabled?"禁用":"开启";
        this.$confirm('确定要'+operation+obj.account+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeState(obj.id);
          this.$message({
            type: 'success',
            message: operation+'成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+operation
          });
        });
      },
      changeState(id){
        axios.put("/admin-user/disable",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      resetPassword(id){
        axios.put("/admin-user/reset",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      pageInfo(){
        if (this.searchDateArr !=  null && this.searchDateArr != ''){
          this.searchInfo.searchDate = this.searchDateArr.join('_');
        }
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/earlyWarning',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;

          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },

      getCustomersTypeList(){
        axios.get('/dict/code',{
          params: {code:102}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.customersTypeList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
      getSalesmanAndPartnerList(){
        axios.get('/admin-user/salesmanAndPartnerList',{
          params: {}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.salesmanAndPartnerList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
    },filters: {
      showState(val){
        if (val){
          return "可用";
        }
        return "不可用"
      },
      showWarningStatus(val){
        if (val == 0){
          return "未处理";
        }
        if (val == 1){
          return "处理中";
        }
        if (val == 2){
          return "已处理";
        }
        return "--"
      },
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }
  }
  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }


</style>
